import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";
import ErrorFallbackModal from "components/Modal/ErrorFallbackModal";
import { useDispatch, useSelector } from "react-redux";
import ModalsHolder from "layout/discovery/ModalsHolder";
import { AlertsHolder } from "components/Alert";
import DiscoveryHeader from "layout/discovery/header";
import DiscoveryFolder from "layout/discovery/folder/DiscoveryFolder";
import DiscoveryDocument from "layout/discovery/document/DiscoveryDocument";
import { setSelectedFolderAndDocument } from "slices/discovery/discoverySlice";
import { fetchThemes } from "slices/discovery/actions/theme";
import { fetchSnapshots } from "slices/discovery/actions/snapshot";
import { getDiscoveryIgnoreListWithFreq } from "slices/settings/actions/discoveryIgnoreList";
import {
  selectAddToDictPanel,
  selectSnapshots,
} from "slices/discovery/selectors";
import AddToDictPanel from "layout/discovery/AddToDictPanel";

const Discovery = ({ vtId, folderId, title }) => {
  const dispatch = useDispatch();
  const firstRun = useRef(true);

  const documentView = folderId !== undefined;
  const { show: showAddToDictPanel } = useSelector(selectAddToDictPanel);

  let folder;
  let document;
  if (folderId === undefined) {
    folder = vtId;
  } else {
    folder = folderId;
    document = Number(vtId);
  }

  useEffect(() => {
    dispatch(
      setSelectedFolderAndDocument({ folderId: folder, documentId: document })
    );
    dispatch(fetchThemes());
    dispatch(fetchSnapshots());
    dispatch(getDiscoveryIgnoreListWithFreq());
  }, [dispatch]);

  return (
    <div className="discovery">
      <ErrorBoundary FallbackComponent={ErrorFallbackModal}>
        <SpinnerWithLoadMask opacity={0.7} fullScreen />
        <ModalsHolder />
        <AlertsHolder />
        <div className="discovery__container">
          <DiscoveryHeader title={title} documentView={documentView} />
          {documentView ? <DiscoveryDocument /> : <DiscoveryFolder />}
          {showAddToDictPanel && <AddToDictPanel />}
        </div>
      </ErrorBoundary>
    </div>
  );
};

Discovery.propTypes = {
  vtId: PropTypes.number.isRequired,
  folderId: PropTypes.number,
  title: PropTypes.string.isRequired,
};

export default Discovery;
